import { addSubscriptionInterceptor } from "../../libs/helpers";

import { usersApi } from "./users/axios";
import { saleApi } from "./sale/axios";
import { quotationApi } from "./quotation/axios";
import { subscriptionApi } from "./subscription/axios";
import { planApi } from "./plan/axios";
import { purchaseOrderApi } from "./purchase-order/axios";
import { supplierApi } from "./supplier/axios";
import { taskApi } from "./task/axios";
import { storageFileApi } from "./storage-file/axios";
import { profileApi } from "./profile/axios";
import { profileTaskApi } from "./profile-task/axios";
import { whatsappApi } from "./whatsapp/axios";
import { userStockifyApi } from "./user-stockify/axios";
import { sriBrowserPoolApi } from "./sri-browser-pool";
import { voidedDocApi } from "./voided-document";
import { emittedRetentionDocApi } from "./emitted-retention-document";

// Instancias de módulos gateados por plan / con cuotas — para que el
// interceptor reescriba PLAN_FEATURE_NOT_INCLUDED / PLAN_LIMIT_REACHED /
// PLAN_DOCUMENT_LIMIT_REACHED a texto legible también en sus toasts.
import { recurrenceApi } from "./recurrence/axios";
import { bulkImportApi } from "./bulk-import/axios";
import { reportDispatchApi } from "./report-dispatch/axios";
import { backupApi } from "./backup/axios";
import { bankApi } from "./banks/axios";
import { cashRegisterApi } from "./cash-register/axios";
import { cashRegisterMovementApi } from "./cash-register-movement/axios";
import { accountReceivableApi } from "./account-receivable/axios";
import { accountPayableApi } from "./account-payable/axios";
import { debitNoteApi } from "./debit-note/axios";
import { remissionGuideApi } from "./remission-guide/axios";
import { expenseApi } from "./expense/axios";
import { categoriaGastoApi } from "./categorias-gasto/axios";
import { gastosReportApi } from "./gastos-report/axios";
import { emittedRetentionApi } from "./emitted-retention/axios";
import { retentionCodeApi } from "./retention-code/axios";
import { retentionDocApi } from "./retention-document/axios";
import { branchApi } from "./branch/axios";
import { productApi } from "./product/axios";

export const setupAllInterceptors = () => {
  const instances = [
    usersApi,
    saleApi,
    quotationApi,
    subscriptionApi,
    planApi,
    purchaseOrderApi,
    supplierApi,
    taskApi,
    storageFileApi,
    profileApi,
    profileTaskApi,
    whatsappApi,
    userStockifyApi,
    sriBrowserPoolApi,
    voidedDocApi,
    emittedRetentionDocApi,
    // gateados por plan / con cuotas
    recurrenceApi,
    bulkImportApi,
    reportDispatchApi,
    backupApi,
    bankApi,
    cashRegisterApi,
    cashRegisterMovementApi,
    accountReceivableApi,
    accountPayableApi,
    debitNoteApi,
    remissionGuideApi,
    expenseApi,
    categoriaGastoApi,
    gastosReportApi,
    emittedRetentionApi,
    retentionCodeApi,
    retentionDocApi,
    branchApi,
    productApi,
  ];

  instances.forEach(addSubscriptionInterceptor);
};
